import { BillingProduct, Currency } from '@citruscamps/citrus-client'
import React from 'react'
import { ReactComponent as UndrawBusinessShopBasketball } from '../../../../../images/undraw_business_shop_basketball.svg'
import { ReactComponent as UndrawChildren } from '../../../../../images/undraw_children_4rtb.svg'
import { ReactComponent as UndrawRunningWild } from '../../../../../images/undraw_running_wild_ni0y.svg'
import { ReactComponent as UndrawTeachingJuniorSoccer } from '../../../../../images/undraw_teaching_junior_soccer.svg'
import { Address } from '../../../../../utils/address'
import { toCurrency } from '../../../../../utils/currency'

interface IProps {
  product: BillingProduct
  language: string
  address?: Address
}

export const PlanGraphic = ({ product }: Pick<IProps, 'product'>) => {
  switch (product.type) {
    case 'pro':
      return <UndrawBusinessShopBasketball className="img-fluid m-auto" />
    case 'standard':
      return <UndrawTeachingJuniorSoccer className="img-fluid m-auto" />
    case 'free':
      return <UndrawChildren className="img-fluid m-auto" />
    default:
      return <UndrawRunningWild className="img-fluid m-auto" />
  }
}

export const PlanDescription = ({ product, language, address }: IProps) => {
  const price: Currency = toCurrency({
    amount:
      product.interval === 'month'
        ? product.amount.major_value
        : Math.round(product.amount.major_value / 12),
    currency: product.amount.currency_code,
    language,
  })
  return (
    <div className="m-auto">
      <div className="h1 mb-0">
        <sup style={{ fontSize: '50%', top: '-0.75rem' }}>
          {price.display.replace(/[0-9]|,|\./g, '')}
        </sup>
        <span>{price.major_value}</span>
      </div>
      <div className="text-body-secondary small ms-3">
        billed {product.interval === 'month' ? 'monthly' : 'annually'}
      </div>
      {price.major_value !== 0 && (
        <div className="text-body-secondary small ms-3">after 30-day free trial</div>
      )}
      {address?.country_short_code === 'CA' && (
        <div className="text-body-secondary small ms-3">+ taxes</div>
      )}
    </div>
  )
}
